module.exports = __webpack_public_path__ + "img/siteOil.3acfb9ec.png";